export const LABEL_PAGINATION = {
    GO_TO_PAGE: 'GO',
    LABEL: 'Go to page',
    BUTTON_LABEL: '',
};
